import Vue from 'vue';
import Vuex from 'vuex';
import { Store, type StoreOptions } from 'vuex';

import { AlertNotificationModule } from './modules/alertNotificationModule';
import { B2CModule } from './modules/b2cModule';
import { ClubModule } from './modules/clubModule';
import { ClubsModule } from './modules/clubsModule';
import { NearestClubModule } from './modules/nearestClubModule';
import { EmployeeProfileModule } from './modules/employeeProfileModule';
import { ProfileModule } from './modules/profileModule';
import { ProspectProfileModule } from './modules/prospectProfileModule';
import { UrlModule } from './modules/urlModule';
import { RecentClubModule } from './modules/recentClubModule';
import { NavigationModule } from './modules/navigationModule';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

Vue.use(Vuex);

export const storeOptions: StoreOptions<ltFramework.IRootState> = {
	state: {
		version: '1.0.0'
	},
	// strict: process.env.NODE_ENV === 'development',
	modules: {
		alertNotificationModule: AlertNotificationModule,
		b2cModule: B2CModule,
		clubModule: ClubModule,
		clubsModule: ClubsModule,
		nearestClubModule: NearestClubModule,
		recentClubModule: RecentClubModule,
		employeeProfileModule: EmployeeProfileModule,
		profileModule: ProfileModule,
		prospectProfileModule: ProspectProfileModule,
		urlModule: UrlModule,
		navigationModule: NavigationModule
	}
};

const store = new Store<ltFramework.IRootState>(storeOptions);

export default store;
